import JobListingJobCardList from '@/app/modules/JobListingJobCardList';
import { IJobDetail, JobSearchWebCriteria } from '@/app/types/jobs';
import cx from 'classnames';

import { Typography } from '@material-ui/core';

import styles from './SimilarJobsSection.module.scss';

type SimilarJobsSectionProps = {
  readonly jobs: IJobDetail[];
  readonly isUserLoggedIn: boolean;
  readonly query: JobSearchWebCriteria;
  readonly grade: string;
  readonly hasSearchResults: boolean;
  readonly speciality?: string;
  readonly rootSpeciality?: string;
  readonly subspeciality?: string;
  readonly className?: string;
};
function SimilarJobsSection({
  jobs,
  isUserLoggedIn,
  query,
  grade,
  speciality,
  rootSpeciality,
  subspeciality,
  className,
  hasSearchResults,
}: SimilarJobsSectionProps) {
  const getSpecialityMessage = () => {
    if (!rootSpeciality && !speciality) {
      return null;
    }

    return `- ${rootSpeciality}${subspeciality ? ` - ${subspeciality}` : ''}`;
  };
  return (
    <div
      className={cx(styles.similarJobCard, className)}
      data-testid="job-search-similar-jobs-results"
    >
      <Typography component={hasSearchResults ? 'h2' : 'h1'} className={styles.heading}>
        Similar results to {grade} {getSpecialityMessage()}:
      </Typography>
      <JobListingJobCardList
        jobs={jobs}
        isUserLoggedIn={isUserLoggedIn}
        query={query}
        isHighlighted={true}
        ctaPosition="bottom"
      />
    </div>
  );
}

export default SimilarJobsSection;
